import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  ValueDisruption,
  MetricsSection,
  DigestSection,
  UGCSection,
  MemSection,
  PlanEvolucion,
  WhyTno,
  AreYouReady,
} from './components';

const LandingMediaKitDaka = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container>
        <Hero themeMode={themeMode} />
      </Container>
      <Container sx={{ pt: { xs: 1, sm: 2 } }}>
        <ValueDisruption />
      </Container>
      <Container>
        <MetricsSection />
      </Container>
      <Container>
        <DigestSection />
      </Container>
      <Container>
        <UGCSection />
      </Container>
      <Container>
        <MemSection />
      </Container>
      <Container>
        <PlanEvolucion />
      </Container>
      <Container>
        <WhyTno />
      </Container>
      <Container>
        <AreYouReady />
      </Container>
    </Box>
  );
};

LandingMediaKitDaka.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitDaka;
